import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUmbrellaSecurity: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="umbrella-security"><path d="M12.0007 15.25V19.3267C12.0007 20.3889 11.1396 21.25 10.0774 21.25C9.16061 21.25 8.37127 20.6029 8.19147 19.7039L8.00069 18.75M12.0007 2.75V4.75M12.0007 4.75C7.43899 4.75 3.62824 7.96518 2.71094 12.253H21.2904C20.3731 7.96518 16.5624 4.75 12.0007 4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUmbrellaSecurity;
